import { getConfigValue } from '../lib/public-env/get-config-value';

export const PORTAL_REGION = {
  USA: 'usa',
  EUROPE: 'europe',
} as const;

export type PortalRegion = (typeof PORTAL_REGION)[keyof typeof PORTAL_REGION];

type PortalRegionConfig = {
  rootDomain: string;
  portalAppUrl: string;
  gatewayUrl: string;
};

export const PORTAL_REGION_CONFIG: Record<PortalRegion, PortalRegionConfig> = {
  [PORTAL_REGION.USA]: {
    rootDomain: 'terra.security',
    portalAppUrl: 'https://tester.terra.security',
    gatewayUrl: 'https://api.terra.security',
  },
  [PORTAL_REGION.EUROPE]: {
    rootDomain: 'eu.terra.security',
    portalAppUrl: 'https://tester.eu.terra.security',
    gatewayUrl: 'https://api.eu.terra.security',
  },
};

const ROOT_DOMAIN_TO_REGION: Record<string, PortalRegion> = {
  [PORTAL_REGION_CONFIG[PORTAL_REGION.USA].rootDomain]: PORTAL_REGION.USA,
  [PORTAL_REGION_CONFIG[PORTAL_REGION.EUROPE].rootDomain]: PORTAL_REGION.EUROPE,
};

export const PORTAL_REGION_ORDER: PortalRegion[] = [
  PORTAL_REGION.USA,
  PORTAL_REGION.EUROPE,
];

export function resolvePortalRegionFromRootDomain(
  rootDomain: string,
): PortalRegion | null {
  const normalized = rootDomain.trim().toLowerCase();
  return ROOT_DOMAIN_TO_REGION[normalized] ?? null;
}

export function isPortalRegionSwitchAvailable(rootDomain: string): boolean {
  return resolvePortalRegionFromRootDomain(rootDomain) !== null;
}

export function isPortalRegionSwitcherEnabled(): boolean {
  return getConfigValue('NEXT_PUBLIC_SHOW_REGION_SWITCHER') === 'true';
}

export function shouldShowSignInRegionSelector({
  hasElectronDomainApi,
  rootDomain,
}: {
  hasElectronDomainApi: boolean;
  rootDomain: string;
}): boolean {
  if (!isPortalRegionSwitcherEnabled()) {
    return false;
  }

  if (hasElectronDomainApi) {
    return true;
  }

  return isPortalRegionSwitchAvailable(rootDomain);
}

export function getPortalRegionPortalAppUrl(region: PortalRegion): string {
  return PORTAL_REGION_CONFIG[region].portalAppUrl;
}
